import PropTypes from "prop-types";
import React from "react";

const RoundedImg = ({ src, width, height, style }) => {
  return (
    <div
      className="flex align-center justify-center"
      style={{
        height: height,
        width: width,
        borderRadius: "50%",
        background: `url(${src})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        ...style,
      }}
    >
      {/* <img
        src={src}
        alt={random}
        loading="lazy"
        style={{
          width: width,
          height: height,
          objectFit: "cover",
          borderRadius: "50%",
          ...style,
        }}
      /> */}
    </div>
  );
};

export default RoundedImg;
RoundedImg.propTypes = {
  src: PropTypes.elementType.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  style: PropTypes.object,
};
